export default {
  getConfigHeader: state => state.header,
  getConfigFooter: state => state.footer,
  getConfigSidebar: state => state.sidebar,
  getConfigMenu: state => state.menu,
  getConfigLayout: state => state.config,
  getConfigLogin: state => state.login,
  getConfigTheme: state => state.theme,
  getBreadcrumbs: state => state.breadcrumbs,
  getDialogs: state => dialog => state.dialogs[dialog],
  getConfigLoading: state => state.loading,
  getConfigPaths: state => state.paths
};
